/**
 * 出货 Tips
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param className 注意！是加入span 标签的样式
 **/
import React from "react";
import Lang from '@components/Lang/Lang';
const Tips = ({item={},className=""}) =>{
    // const {item, className } = this.props;
    return (<p className={`mt_6`}>
        {/*  中转城市名称  预约类型名称 */}
        <span className={`spanTag spanBlue mr_8${className?" "+className:""}`}><i className={"ri-hotel-fill mr_2 font_16"} /> {item.transitCityName}{Lang({id: 'CangKu', default: '仓库'})}</span>
        <span className={`spanTag spanPurple mr_8${className?" "+className:""}`}>{item.typeName}</span>
        {item.hasDeliveryService==1?<span className={`spanTag spanWarn${className?" "+className:""}`}>{Lang({id: 'XuSongChe', default: '需送车'})}</span>:null}
    </p>);
}
export default Tips;

